import React, { useCallback } from 'react';
import {
  toBN,
  formatAmountBN,
  VaultUpgradable,
  HedgedLP,
  useInputState,
} from '@sc1/common';
import { useERC20, useCall2, useSend } from '@sc1/common/hooks';
import { Column, InputMax, Box } from '../core';
import { StatusButton } from '../StatusButton';

interface WithdrawFromStrategyProps {
  vault: VaultUpgradable | undefined;
  strategy: HedgedLP;
  address: string;
  disabled: boolean;
}

export const WithdrawFromStrategy = ({
  vault,
  strategy,
  address,
  disabled,
}: WithdrawFromStrategyProps): JSX.Element => {
  const { amountStr, amountBN, setAmountWithMax, setMax } = useInputState();

  const { sendTx, txStatus } = useSend();

  const { res: underlyingAddress } = useCall2(vault?.UNDERLYING);
  const underlying = useERC20(underlyingAddress);
  const { res: underlyingSymbol } = useCall2(underlying?.symbol);
  const { res: dec } = useCall2(underlying?.decimals);

  const { res: balanceBN = toBN(0) } = useCall2(
    strategy?.['balanceOfUnderlying()']
  );
  const balanceFmt = formatAmountBN(balanceBN, dec, false, 2, false);

  const withdrawFromStrategy = useCallback(
    () =>
      vault &&
      address &&
      sendTx(vault, 'withdrawFromStrategy', [address, amountBN]),
    [vault, address, sendTx, amountBN]
  );

  return (
    <Column sx={{ flex: 1 }}>
      <Box sx={{ fontSize: 1 }}>
        Balance: {balanceFmt} {underlyingSymbol}
      </Box>
      <InputMax
        my={2}
        disabled={disabled}
        value={amountStr}
        type="number"
        placeholder="0"
        onMaxClick={() => {
          setMax(balanceBN, dec);
        }}
        onChange={(e) => {
          setAmountWithMax(e.target.value, dec, balanceBN);
        }}
      />
      <StatusButton
        disabled={disabled}
        onClick={withdrawFromStrategy}
        status={txStatus}
      >
        Withdraw
      </StatusButton>
    </Column>
  );
};
